// @ts-nocheck
/* eslint-disable react/prop-types */
import React, { memo, useMemo } from 'react';
import NodeHandle from './NodeHandle';

const NodeHandles = memo(({ handles, fallbackHandles = [] }) => {
  const resolvedHandles = useMemo(() => {
    if (Array.isArray(handles) && handles.length > 0) return handles;
    return fallbackHandles;
  }, [handles, fallbackHandles]);

  return resolvedHandles.map((handle, index) => {
    const key = handle.id ?? `${handle.type}-${handle.position}-${index}`;
    return (
      <NodeHandle
        key={key}
        type={handle.type}
        position={handle.position}
        id={handle.id}
        color={handle.color}
        size={handle.size}
        offset={handle.offset}
      />
    );
  });
});

NodeHandles.displayName = 'NodeHandles';

export default NodeHandles;
